import { createContext, useContext } from 'react'
import { useAuth } from '../AuthContext'
import useVisitBasket from '../hooks/useVisitBasket'
import useProductFavorites from '../hooks/useProductFavorites'

/**
 * Panier de visite + favoris produits (S48) — instancies UNE fois ici et
 * consommes par hook (badge de la barre basse, Favoris, Compte...), au lieu
 * d'etre drilles depuis App. `deconnecter()` remplace le wrapper handleLogout
 * d'App : vider les paniers en memoire PUIS fermer la session (le reset de la
 * casquette et de `manrina_isProducer` vit dans contexts/casquette.jsx).
 */

const PanierCtx = createContext(null)

export function PanierProvider({ children }) {
  const { logout } = useAuth()
  const basket = useVisitBasket()
  const productFavs = useProductFavorites()

  const deconnecter = () => {
    basket.clear()
    productFavs.clear()
    logout()
  }

  return (
    <PanierCtx.Provider value={{ basket, productFavs, deconnecter }}>
      {children}
    </PanierCtx.Provider>
  )
}

export function usePanier() {
  const v = useContext(PanierCtx)
  if (!v) throw new Error('usePanier hors de PanierProvider')
  return v
}
